module.exports = __webpack_public_path__ + "static/media/class-passes.0d88eb40.svg";